import {browserHistory} from 'react-router';
import axios from 'axios';

const baseEndpoint = 'v1/channeloperations';

const ChannelOperationService = {

  /*getChannel( id ) {
   return axios
   .get( `${baseEndpoint}/${id}` )
   },*/

  getChannelOperations( params ) {
    return axios
      .get( `${baseEndpoint}`, { params } )
  },

  saveMessage( data ) {
    return axios
      .post( baseEndpoint, data )
  },

  saveMessages( data ) {
    return axios
      .post( `${baseEndpoint}/massives`, data )
  },

  sendEmail( data ) {
    return axios
      .post( `${baseEndpoint}/directmails`, data )
  },

  sendBroadcastMsg( data ) {
    return axios
      .post( `${baseEndpoint}/broadcasts`, data )
  },
};

export default ChannelOperationService;



// WEBPACK FOOTER //
// ./services/ChannelOperationService.js